import { axiosClient } from "@/lib/axiosClient";

export interface ExportPeriodExcelParams {
    search?: string;
    package_id?: string;
    status?: string;
    registration_type?: string;
    institution?: string;
    gender?: string;
    blood_type?: string;
    clothing_size?: string;
    payment_date_from?: string;
    payment_date_to?: string;
}

export const exportPeriodExcel = async (
    periodId: string,
    params?: ExportPeriodExcelParams
) => {
    // Bersihkan parameter 'all' atau string kosong
    const cleanParams: Record<string, string> = {};
    if (params?.search && params.search.trim() !== "") {
        cleanParams.search = params.search.trim();
    }
    if (params?.package_id && params.package_id !== "all") {
        cleanParams.package_id = params.package_id;
    }
    if (params?.status && params.status !== "all") {
        cleanParams.status = params.status;
    }
    if (params?.registration_type && params.registration_type !== "all") {
        cleanParams.registration_type = params.registration_type;
    }
    if (params?.institution && params.institution !== "all") {
        cleanParams.institution = params.institution;
    }
    if (params?.gender && params.gender !== "all") {
        cleanParams.gender = params.gender;
    }
    if (params?.blood_type && params.blood_type !== "all") {
        cleanParams.blood_type = params.blood_type;
    }
    if (params?.clothing_size && params.clothing_size !== "all") {
        cleanParams.clothing_size = params.clothing_size;
    }
    if (params?.payment_date_from) {
        cleanParams.payment_date_from = params.payment_date_from;
    }
    if (params?.payment_date_to) {
        cleanParams.payment_date_to = params.payment_date_to;
    }

    const response = await axiosClient.get(
        `/periods/${periodId}/export-excel`,
        {
            params: cleanParams,
            responseType: "blob",
            withCredentials: true,
        }
    );

    const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    // Berikan nama file yang informatif sesuai periode dan tanggal unduh
    const timestamp = new Date().toISOString().slice(0, 10);
    a.download = `rekap-peserta-periode-${periodId}-${timestamp}.xlsx`;
    a.click();
    window.URL.revokeObjectURL(url);
};

